export const AI_PLANNER_EMBEDDED_CONFLUENCE_SOURCE: any = 'ai-planner';

export const PARENT_PRODUCT_MODULE_NAME: any = 'parentProduct';

export const MAX_SELECTED_TEXT_LENGTH = 20_000;

export type SendToParentProductPayload =
	| {
			contentId: string;
			contentType?: 'page' | 'blogpost' | 'whiteboard';
			eventType: 'embedded-confluence.text-selection.changed';
			selectedText: string;
			selectionLocalIds?: string[];
			sourceTitle?: string;
			sourceUrl?: string;
	  }
	| {
			contentId: string;
			eventType: 'embedded-confluence.text-selection.cleared';
	  };
